import {call, put, takeEvery} from "redux-saga/effects";

import {
    GET_ALERT_LOG_COUNT_BY_INTEGRATION_TYPE,
    GET_ALERT_LOG_COUNT_BY_APPLICATION_SERVICE,
    GET_MOST_FREQUENT_ALERTS,
    GET_ALERT_OPEN_AND_CLOSE_WITHIN_5_MINUTES,
    GET_ALERT_OPEN_AND_CLOSE_WITHIN_5_MINUTES_COUNT,
    GET_MOST_FREQUENT_ALERTS_AZURE,
    GET_MOST_FREQUENT_ALERTS_DATADOG,
    GET_MOST_FREQUENT_ALERTS_GCP,
    GET_MOST_FREQUENT_ALERTS_CLOUDWATCH,
    GET_MOST_FREQUENT_ALERTS_NEW_RELIC,
    GET_MOST_FREQUENT_OTHER_ALERTS, GET_MOST_FREQUENT_ALERTS_OPEN_AND_CLOSE_WITHIN_5_MINUTES, ACCEPT_THE_SUGGESTION
} from "./actionTypes";

import {
    getAlertLogCountByIntegrationTypeSuccess,
    getAlertLogCountByIntegrationTypeFail,
    getAlertLogCountByApplicationServiceSuccess,
    getAlertLogCountByApplicationServiceFail,
    getMostFrequentAlertsSuccess,
    getMostFrequentAlertsFail,
    getAlertOpenAndCloseWithin5MinutesSuccess,
    getAlertOpenAndCloseWithin5MinutesFail,
    getAlertOpenAndCloseWithin5MinutesCountSuccess,
    getAlertOpenAndCloseWithin5MinutesCountFail,
    getMostFrequentAlertsAzureFail,
    getMostFrequentAlertsAzureSuccess,
    getMostFrequentAlertsAwsFail,
    getMostFrequentAlertsAwsSuccess,
    getMostFrequentAlertsNewRelicFail,
    getMostFrequentAlertsNewRelicSuccess,
    getMostFrequentAlertsDataDogFail,
    getMostFrequentAlertsDataDogSuccess,
    getMostFrequentAlertsGcpSuccess,
    getMostFrequentAlertsGcpFail,
    getMostFrequentOtherAlertsSuccess,
    getMostFrequentOtherAlertsFail,
    getMostFrequentAlertsOpenAndClosedWithin5MinutesSuccess,
    getMostFrequentAlertsOpenAndClosedWithin5MinutesFail, acceptTheSuggestionSuccess, acceptTheSuggestionFail
} from "./actions";

import {
    getAlertLogCountByIntegrationTypeURL,
    getAlertLogCountByApplicationServiceURL,
    getMostFrequentAlertsURL,
    getAlertsOpenAndCloseWithin5MinURL,
    getAlertsOpenAndCloseWithin5MinCountURL,
    getMostFrequentAlertsAzureUrl,
    getMostFrequentAlertsAwsUrl,
    getMostFrequentAlertsNewRelicUrl,
    getMostFrequentAlertsDatadogUrl,
    getMostFrequentAlertsGcpUrl,
    getMostFrequentOtherAlertsUrl, getMostFrequentAlertsBasedOnIntegrationUrl, postAcceptSuggestionsURL
} from "../../helpers/fakebackend_helper";

import {showNotification} from "components/Common/notification";

function* onGetAlertLogCountByIntegrationType({payload: {teamIds}}) {
    try {
        const response = yield call(getAlertLogCountByIntegrationTypeURL, teamIds);
        yield put(getAlertLogCountByIntegrationTypeSuccess(response));
    } catch (error) {
        yield put(getAlertLogCountByIntegrationTypeFail(error.message));
    }
}

function* onGetAlertLogCountByApplicationService({payload: {teamIds}}) {
    try {
        const response = yield call(getAlertLogCountByApplicationServiceURL, teamIds);
        yield put(getAlertLogCountByApplicationServiceSuccess(response));
    } catch (error) {
        yield put(getAlertLogCountByApplicationServiceFail(error.message));
    }
}

function* onGetMostFrequentAlerts({payload: {teamIds}}) {
    try {
        const response = yield call(getMostFrequentAlertsURL, teamIds);
        yield put(getMostFrequentAlertsSuccess(response));
    } catch (error) {
        yield put(getMostFrequentAlertsFail(error.message));
    }
}

function* onGetAlertOpenAndCloseWithin5Minutes({payload: {page_filters}}) {
    try {
        const response = yield call(getAlertsOpenAndCloseWithin5MinURL, page_filters);
        yield put(getAlertOpenAndCloseWithin5MinutesSuccess(response));
    } catch (error) {
        yield put(getAlertOpenAndCloseWithin5MinutesFail(error.message));
    }
}

function* onGetAlertOpenAndCloseWithin5MinutesCount({payload: {page_filters}}) {
    try {
        const response = yield call(getAlertsOpenAndCloseWithin5MinCountURL, page_filters);
        yield put(getAlertOpenAndCloseWithin5MinutesCountSuccess(response));
    } catch (error) {
        yield put(getAlertOpenAndCloseWithin5MinutesCountFail(error.message));
    }
}

function* onGetMostFrequentAlertsAzure({payload: {page_filters}}) {
    try {
        const response = yield call(getMostFrequentAlertsAzureUrl, page_filters);
        yield put(getMostFrequentAlertsAzureSuccess(response));
    } catch (error) {
        yield put(getMostFrequentAlertsAzureFail(error.message));
    }
}

function* onGetMostFrequentAlertsAws({payload: {page_filters}}) {
    try {
        const response = yield call(getMostFrequentAlertsAwsUrl, page_filters);
        yield put(getMostFrequentAlertsAwsSuccess(response));
        showNotification("success", "Alerts Fetched Successfully")
    } catch (error) {
        yield put(getMostFrequentAlertsAwsFail(error.message));
    }
}

function* onGetMostFrequentAlertsNewRelic({payload: {page_filters}}) {
    try {
        const response = yield call(getMostFrequentAlertsNewRelicUrl, page_filters);
        yield put(getMostFrequentAlertsNewRelicSuccess(response));
    } catch (error) {
        yield put(getMostFrequentAlertsNewRelicFail(error.message));
    }
}

function* onGetMostFrequentAlertsDatadog({payload: {page_filters}}) {
    try {
        const response = yield call(getMostFrequentAlertsDatadogUrl, page_filters);
        yield put(getMostFrequentAlertsDataDogSuccess(response));
    } catch (error) {
        yield put(getMostFrequentAlertsDataDogFail(error.message));
    }
}

function* onGetMostFrequentAlertsGCP({payload: {page_filters}}) {
    try {
        const response = yield call(getMostFrequentAlertsGcpUrl, page_filters);
        yield put(getMostFrequentAlertsGcpSuccess(response));
    } catch (error) {
        yield put(getMostFrequentAlertsGcpFail(error.message));
    }
}

function* onGetMostFrequentAlertsExternalIntegrations({payload: {page_filters}}) {
    try {
        const response = yield call(getMostFrequentOtherAlertsUrl, page_filters);
        yield put(getMostFrequentOtherAlertsSuccess(response));
    } catch (error) {
        yield put(getMostFrequentOtherAlertsFail(error.message));
    }
}

function* onGetMostFrequentAlertsBasedOnIntegration({payload: {page_filters}}) {
    try{
        const response = yield call(getMostFrequentAlertsBasedOnIntegrationUrl, page_filters);
        yield put(getMostFrequentAlertsOpenAndClosedWithin5MinutesSuccess(response));
    } catch (error) {
        yield put(getMostFrequentAlertsOpenAndClosedWithin5MinutesFail(error.message));
    }
}

function* onPostAcceptSuggestions({payload: suggestionId}) {
    try {
        const response = yield call(postAcceptSuggestionsURL, suggestionId);
        yield put(acceptTheSuggestionSuccess(response));
    } catch (error) {
        yield put(acceptTheSuggestionFail(error.message));
    }
}

function* alertAnalyticsSaga() {
    yield takeEvery(GET_ALERT_LOG_COUNT_BY_INTEGRATION_TYPE, onGetAlertLogCountByIntegrationType);
    yield takeEvery(GET_ALERT_LOG_COUNT_BY_APPLICATION_SERVICE, onGetAlertLogCountByApplicationService);
    yield takeEvery(GET_MOST_FREQUENT_ALERTS, onGetMostFrequentAlerts)
    yield takeEvery(GET_ALERT_OPEN_AND_CLOSE_WITHIN_5_MINUTES, onGetAlertOpenAndCloseWithin5Minutes)
    yield takeEvery(GET_ALERT_OPEN_AND_CLOSE_WITHIN_5_MINUTES_COUNT, onGetAlertOpenAndCloseWithin5MinutesCount)
    yield takeEvery(GET_MOST_FREQUENT_ALERTS_AZURE, onGetMostFrequentAlertsAzure)
    yield takeEvery(GET_MOST_FREQUENT_ALERTS_CLOUDWATCH, onGetMostFrequentAlertsAws)
    yield takeEvery(GET_MOST_FREQUENT_ALERTS_NEW_RELIC, onGetMostFrequentAlertsNewRelic)
    yield takeEvery(GET_MOST_FREQUENT_ALERTS_DATADOG, onGetMostFrequentAlertsDatadog)
    yield takeEvery(GET_MOST_FREQUENT_ALERTS_GCP, onGetMostFrequentAlertsGCP)
    yield takeEvery(GET_MOST_FREQUENT_OTHER_ALERTS, onGetMostFrequentAlertsExternalIntegrations)
    yield takeEvery(GET_MOST_FREQUENT_ALERTS_OPEN_AND_CLOSE_WITHIN_5_MINUTES, onGetMostFrequentAlertsBasedOnIntegration)
    yield takeEvery(ACCEPT_THE_SUGGESTION, onPostAcceptSuggestions)

}

export default alertAnalyticsSaga;
